import { Button } from "@themesberg/react-bootstrap";
import React from "react";

export const TableRow = (props) => {
  const { ticket, user, netValue, fee, isPaid, id, grossValue, tax } =
    props.data;

  const { onPaidPress } = props;
  const numberFormatter = new Intl.NumberFormat("vn-VI", {});

  return (
    <tr>
      <td className="text-center">
        <Button onClick={() => props.onShowDetailPress(props.data)}>
          Chi tiết
        </Button>
      </td>
      <td>
        <>
          <b>{(user && user.name) || ""}</b>
          <br />
          SĐT:{" "}
          <span>
            <strong className={`text-primary`}>
              {(user && user.phone) || ""}
            </strong>
          </span>
          <br />
          {user && user.bank && (
            <>
              Ngân hàng: <b>{user.bank.shortName}</b>
              <br />
            </>
          )}
          {user && user.bankAccountNumber && (
            <>
              STK: <b>{user.bankAccountNumber}</b>
              <br />
            </>
          )}
          {user && user.bankAccountName && (
            <>
              Tên TK: <b>{user.bankAccountName}</b>
              <br />
            </>
          )}
        </>
      </td>
      <td className="text-center">{ticket.cartId}</td>
      <td className="text-center">
        {ticket.Channel.name}
        <br />
        {ticket.resultDate}
      </td>
      <td className="text-center">
        {ticket.LotoType}
        <br />
        {ticket.numbers}
        <br />
        {new Intl.NumberFormat("vn-VI", {}).format(ticket.value)}
      </td>
      <td className="text-center text-success">
        {numberFormatter.format(grossValue || 0)}
      </td>
      <td className="text-center">{numberFormatter.format(tax || 0)}</td>
      <td className="text-center">{numberFormatter.format(fee || 0)}</td>
      <td className="text-center text-primary">
        {numberFormatter.format(netValue || 0)}
      </td>
      <td className="text-center text-success">
        {isPaid ? (
          "Đã trả thưởng"
        ) : (
          <Button
            variant="danger"
            className="m-1"
            onClick={() => onPaidPress(id, user.phone, ticket.id)}
          >
            Trả thưởng
          </Button>
        )}
      </td>
    </tr>
  );
};
